import { Add as AddIcon } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import { Tag } from "pepsico-ds";
import PropTypes from "prop-types";
import { useState } from "react";
import "./keywordManagement.scss";

const KeywordChips = ({ keywords = [], onChange, disabled = false }) => {
  const [newKeyword, setNewKeyword] = useState("");

  // Ensure keywords is always an array
  const keywordsArray = Array.isArray(keywords) ? keywords : [];

  const handleAddKeyword = () => {
    if (newKeyword.trim() && !keywordsArray.includes(newKeyword.trim())) {
      const updatedKeywords = [...keywordsArray, newKeyword.trim()];
      onChange(updatedKeywords);
      setNewKeyword("");
    }
  };

  const handleDeleteKeyword = (keywordToDelete) => {
    const updatedKeywords = keywordsArray.filter(
      (keyword) => keyword !== keywordToDelete
    );
    onChange(updatedKeywords);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddKeyword();
    }
  };

  return (
    <div className="keyword-chips-container">
      <div className="keyword-chips-label">
        Keywords <span className="required-asterisk">*</span>
      </div>

      <div className="keyword-chips-list">
        {keywordsArray.map((keyword) => (
          <Tag
            key={keyword}
            className=""
            text={keyword}
            isRemovable={!disabled}
            isCopyable={false}
            onRemove={disabled ? undefined : () => handleDeleteKeyword(keyword)}
          />
        ))}
      </div>

      {!disabled && (
        <Box className="add-keyword-section" sx={{ mt: 2 }}>
          <TextField
            size="small"
            placeholder="Enter new keyword"
            value={newKeyword}
            onChange={(e) => setNewKeyword(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={disabled}
            sx={{
              minWidth: "200px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontFamily: "Inter",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-input": {
                fontFamily: "Inter",
                fontSize: "12px",
              },
              "& .MuiInputBase-input::placeholder": {
                fontFamily: "Inter",
                fontSize: "12px",
                opacity: 0.6,
              },
            }}
            InputProps={{
              endAdornment: (
                <AddIcon
                  onClick={handleAddKeyword}
                  sx={{
                    cursor: newKeyword.trim() ? "pointer" : "default",
                    color: newKeyword.trim() ? "#1976d2" : "#ccc",
                    fontSize: "20px",
                  }}
                />
              ),
            }}
          />
        </Box>
      )}

      {keywordsArray.length === 0 && (
        <div className="no-keywords-message">
          No keywords added yet. Use the input field above to add keywords.
        </div>
      )}
    </div>
  );
};

KeywordChips.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default KeywordChips;
